import { Search, X } from 'lucide-react'

interface Props {
  value: string
  onChange: (v: string) => void
  placeholder?: string
}

export function SearchInput({ value, onChange, placeholder = 'Search…' }: Props) {
  return (
    <div className="relative">
      <Search size={13} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-ink-dim pointer-events-none" />
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="pl-8 pr-7 py-1.5 text-sm bg-white border border-paper-border rounded-md text-ink placeholder:text-ink-dim
                   focus:outline-none focus:ring-2 focus:ring-accent focus:border-transparent w-52 transition-all"
      />
      {value && (
        <button
          onClick={() => onChange('')}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-ink-dim/60 hover:text-ink transition-colors"
        >
          <X size={12} />
        </button>
      )}
    </div>
  )
}
